class SquareCards extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.updateHeight();
      this.setupResizeObserver();
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  updateHeight() {
    const elements = document.querySelectorAll('counting-column[class*="multicolumn-card-wrapper--"]');
    
    let maxHeight = 0;
    let tallestElement = null;
    
    elements.forEach(function(element) {
      const height = element.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
        tallestElement = element;
      }
    });

    if (maxHeight > 0) {
      document.documentElement.style.setProperty('--tallest-multicolumn-card-height', maxHeight + 'px');
      window.maxMulticolumnCardHeight = maxHeight;
    }
  }

  setupResizeObserver() {
    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(() => {
        this.updateHeight();
      });
      this.observer.observe(this);
    }
  }
}

customElements.define('square-cards', SquareCards);

